import React from "react"
import { cn } from "./cn"

// Tailwind replacement for react-bootstrap <Button variant=...>.
// Variants mirror the old SCSS .btn-* rules (see scss/components/_buttons.scss):
//   success   – yellow fill, green text (primary CTA)
//   primary   – green fill, white text
//   secondary – white fill, green outline
//   danger    – white fill, peach outline
//   link      – text-only
const VARIANTS = {
  success:
    "bg-integria-yellow text-integria-green hover:text-white border border-transparent",
  primary:
    "bg-integria-green text-white border border-transparent hover:bg-integria-green/90",
  secondary:
    "bg-white text-integria-green border border-integria-green hover:bg-integria-green/10",
  danger:
    "bg-white text-integria-green border border-integria-peach hover:bg-integria-peach/10",
  link: "bg-transparent text-integria-green underline border-0 shadow-none hover:text-integria-green/80",
}

export default function Button({
  variant = "primary",
  type = "button",
  className = "",
  disabled = false,
  children,
  ...props
}) {
  const variantClasses = VARIANTS[variant] || VARIANTS.primary
  return (
    <button
      type={type}
      disabled={disabled}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded font-semibold text-sm px-4 py-2.5 shadow-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        variantClasses,
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
